// extracted by mini-css-extract-plugin
module.exports = {"dark":"_15VHtH"};